import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import toBase64 from "helpers/toBase64";
import { languageAdd, languageGetSingle } from "actions/language/requests";

const LanguageEdit = (props) => {
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [flag, setFlag] = useState("");

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const data = {
      id,
      name,
      flag
    };
    props.languageAdd(id, data, () => {
      props.history.push("/language");
    });
  };

  const {
    match,
    languageGetSingle
  } = props;
  const paramId = match && match.params && match.params.id ? match.params.id : false;
  useEffect(() => {
    if (paramId) {
      languageGetSingle(paramId, single => {
        if (!single) {
          return;
        }
        setId(single.id);
        setName(single.name);
        setFlag(single.flag);
      });
    }
  }, [paramId, languageGetSingle]);

  return (
    <div className="w-100 p-2">
      <div className="card">
        <div className="card-header">
          <h4>Language</h4>
        </div>
        <div className="card-body">
          <form
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >

            <div className="mb-3">
              <label>ISO</label>
              <input
                className="form-control"
                type="text"
                value={id}
                placeholder="am, ru, en"
                onChange={ev => setId(ev.target.value)}
              />
            </div>

            <div className="mb-3">
              <label>Name</label>
              <input
                className="form-control"
                type="text"
                value={name}
                placeholder="Name"
                onChange={ev => setName(ev.target.value)}
              />
            </div>

            <div className="mb-3">
              <label>Flag</label>
              <input
                className="form-control"
                accept="image/png"
                type="file"
                placeholder="Upload Image"
                onChange={ev => toBase64(ev.target.files[0])
                  .then(setFlag)}
              />
            </div>

            {flag && (
              <div className="mb-3">
                <img
                  src={flag}
                  alt="flag"
                  className="img-thumbnail"
                  style={{
                    maxWidth: 64,
                    marginTop: 20
                  }}
                />
              </div>
            )}

            <hr/>

            <div className="text-end">
              <button
                className="btn btn-success"
                onClick={handleSubmit}
                disabled={false}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.language.loading,
});

const mapStateToDispatch = dispatch => ({
  languageAdd: bindActionCreators(languageAdd, dispatch),
  languageGetSingle: bindActionCreators(languageGetSingle, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(LanguageEdit);



// WEBPACK FOOTER //
// ./src/views/pages/Language/edit.js